module.exports = __webpack_public_path__ + "static/media/damejidlo.93a4696d.jpg";